import { Link } from 'react-router-dom';
import { allVideos, featuredVideoIds } from '@/mocks/videos';

export default function FeaturedVideos() {
  const featured = featuredVideoIds.map((id) => allVideos.find((v) => v.id === id)).filter(Boolean);

  return (
    <section className="bg-background-100/70 py-10 md:py-14">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-1">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500">
              大家都在看的精彩内容
            </p>
          </div>
          <Link
            to="/category/dianshi"
            className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap transition-colors"
          >
            查看更多 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5" data-product-shop>
          {featured.map((video) => {
            if (!video) return null;
            return (
              <Link
                key={video.id}
                to={`/category/${video.category}`}
                className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all"
              >
                <div className="relative aspect-video overflow-hidden">
                  <img
                    src={video.cover}
                    alt={video.title}
                    title={`${video.title} - 红桃tv高清视频`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                    loading="lazy"
                  />
                  <div className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-xs px-2 py-0.5 rounded">
                    {video.duration}
                  </div>
                  <div className="absolute top-2 left-2">
                    {video.rating >= 9.0 && (
                      <span className="bg-primary-500 text-background-50 text-xs px-2 py-0.5 rounded">热门</span>
                    )}
                  </div>
                </div>
                <div className="p-3 md:p-4">
                  <h3 className="font-medium text-sm md:text-base text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-1">
                    {video.title}
                  </h3>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-2">
                    {video.description}
                  </p>
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span className="flex items-center gap-1">
                      <i className="ri-star-fill text-accent-500"></i>
                      {video.rating}
                    </span>
                    <span className="flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {video.views}
                    </span>
                    <span className="ml-auto flex items-center gap-1">
                      <i className="ri-play-circle-line"></i>
                      播放
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}